import { useFeatureIsOn } from '@growthbook/growthbook-react';
import {
  ABTEST_CHECKOUT_FLOW_FOR_ACCOUNT,
  ABTEST_CHECKOUT_FLOW_FOR_CHECKOUT,
  ABTEST_CHECKOUT_FLOW_FOR_GENERIC_FUNNEL,
} from '@monofront/business/constants';

/** Gates the CKO Flow vs Frames A/B test on the checkout payment page. */
const useCheckoutFlowEnabledForCheckout = () =>
  useFeatureIsOn(ABTEST_CHECKOUT_FLOW_FOR_CHECKOUT);

/** Gates the CKO Flow vs Frames A/B test on the generic-funnel subscription form. */
const useCheckoutFlowEnabledForGenericFunnel = () =>
  useFeatureIsOn(ABTEST_CHECKOUT_FLOW_FOR_GENERIC_FUNNEL);

/** Gates the CKO Flow vs Frames A/B test on the account card forms. */
const useCheckoutFlowEnabledForAccount = () =>
  useFeatureIsOn(ABTEST_CHECKOUT_FLOW_FOR_ACCOUNT);

export {
  useCheckoutFlowEnabledForAccount,
  useCheckoutFlowEnabledForCheckout,
  useCheckoutFlowEnabledForGenericFunnel,
};
